import {APIMethod} from '@enums'

import {fetchData} from 'api/api'
import axios from 'axios'
import qs from 'qs'

import {UserRequest, UserResponse} from '../user'
import {LoginRequest, LoginResponse, OAuthTokenResponse} from './types'

/**
 * Authentication request
 * @param body Authentication payload data
 * @returns A valid token
 */
export const login = async (body: LoginRequest): Promise<LoginResponse> => {
  return fetchData({
    method: APIMethod.POST,
    url: 'authenticate',
    body,
  })
}

/**
 * Registration request
 * @param body User payload data
 * @returns New User data
 */
export const register = async (body: UserRequest): Promise<UserResponse> => {
  return fetchData({
    method: APIMethod.POST,
    url: 'user/register',
    body,
  })
}

/**
 * OAuth token callback
 * @param code Authorization code
 */
export const callbackToken = async (code: string): Promise<OAuthTokenResponse> => {
  const tokenUrl = `${process.env.REACT_APP_HCS_AUTH_URL || ''}/token`
  const redirect_uri = process.env.REACT_APP_HCS_AUTH_REDIRECT_URI || ''
  const clientId = process.env.REACT_APP_HCS_AUTH_CLIENT_ID || ''
  const clientSecret = process.env.REACT_APP_HCS_AUTH_CLIENT_SECRET || ''

  const data = qs.stringify({
    grant_type: 'authorization_code',
    code,
    redirect_uri,
    scope: 'openid email profile',
  })

  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
    Authorization: `Basic ${btoa(`${clientId}:${clientSecret}`)}`,
  }

  const response = await axios.post(tokenUrl, data, {headers})
  return response.data
}

/**
 * Exchange id_token for internal token
 * @param id_token OAuth id_token
 */
export const callbackLogin = async (id_token: string): Promise<LoginResponse> => {
  return fetchData({
    method: APIMethod.POST,
    url: 'sso/husqvarna/exchange',
    body: {id_token},
  })
}
